class RecoomendCatList {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }

  event() {
    const listWrap = document.querySelector('.' + this.el);
    const listInner = document.querySelector('.' + this.el + '__inner');
    const listWrapWidth = listWrap.clientWidth;
    const listPlus = document.querySelector('.' + this.el + '__plus');
    const listNodeList = listWrap.querySelectorAll('a');
    let listInnerTotalWidth = 0;
    const rem = window.innerWidth / 1400 * 10;
    const listInnerTotalGap = ((listNodeList.length - 1) * rem);
    listNodeList.forEach((list) => {
      listInnerTotalWidth += list.clientWidth;
    })
    listInnerTotalWidth += listInnerTotalGap;
    // console.log(listWrapWidth)
    // console.log(listInnerTotalWidth)
    if (listWrapWidth < listInnerTotalWidth) {
      listPlus.style.opacity = '1';
    }

    // スクロールした時の挙動
    let listInnerScroll = 0;
    listInner.addEventListener('scroll', (event) => {
      listInnerScroll = listInner.scrollLeft;
      if (listInnerTotalWidth < (listWrapWidth + listInnerScroll)) {
        listPlus.style.opacity = '0'
      } else {
        // listPlus.style.opacity = '1'
      }
    })
  }
}